module.exports = __webpack_public_path__ + "static/media/googleplay-zh-HK.6416b893.png";